
import React, { Fragment } from 'react';

// Utils

import { appendClassNames } from '@utils/miscellaneous/appendClassNames';




const GridItem = props => {

    const {
        id,
        items,
        design
    } = props;

    const getColumnsQty = qty => {

        // classes are handled in _income_summary.scss

        switch(qty) {
            case 3:
                return 'three';
            case 4:
                return 'four';
            case 5:
                return 'five';
            default:
                return '';
        }
    };

    const Tag = design === 'header' ? 'th' : 'td';

    return (
        <Fragment>
            {
                items.map((item, i, arr) => {

                    const {
                        value,
                        className,
                    } = item;

                    return (
                        <Tag
                            key = { i }
                            dataTestId={`${id}-${i}`}
                            className = { appendClassNames(className, getColumnsQty(arr.length)) }
                        >
                            { value }
                        </Tag>
                    );
                })
            }
        </Fragment>
    );
};

export default GridItem;